// eslint-disable-next-line import/prefer-default-export
export const OS_TYPES = {
  1: 'IOS',
  2: 'Android',
  3: 'Web'
}
